import { createApp } from "vue";
import App from "./App.vue";
import router from "./routers/index.js";
import "element-plus/dist/index.css";

import qkui from "qk-pc-ui";
import { SetProxyHostDict } from "qk-lib-v3";
import "qk-pc-ui/dist/style.css";

window.ProjectHost = process.env.NODE_ENV == "development" ? "http://localhost:56009" : "//saas.ip239.com";
//window.ProjectHost = process.env.NODE_ENV == "development" ? "http://saas.ip239.com" : "http://saas.ip239.com";

window.ProjectHost = "//saas.ip239.com";

createApp(App).use(router).use(qkui).mount("#app");
